import { useMemo } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { get } from 'lodash'

const FormikAutocompleteField = ({ formik, name, label, options, placeholder, freeSolo = false, size }) => {
  const value = get(formik.values, name, '')
  const hasError = formik.touched[name] && Boolean(formik.errors[name])
  const helperText = hasError ? formik.errors[name] : ''

  const selectedOption = useMemo(() => {
    return options.find((o) => o.value === value) || null
  }, [options, value])

  return (
    <Autocomplete
      freeSolo={freeSolo}
      options={options}
      getOptionLabel={(option) => {
        if (typeof option === 'string') return option
        return option.label || option.value || ''
      }}
      value={freeSolo ? (selectedOption || value) : selectedOption}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          formik.setFieldValue(name, newValue)
        } else if (newValue) {
          formik.setFieldValue(name, newValue.value)
        } else {
          formik.setFieldValue(name, '')
        }
      }}
      onInputChange={(event, newInputValue, reason) => {
        if (freeSolo && reason === 'input') {
          formik.setFieldValue(name, newInputValue)
        }
      }}
      onBlur={() => formik.setFieldTouched(name, true)}
      isOptionEqualToValue={(option, val) => {
        if (typeof val === 'string') return option.value === val
        return option.value === val?.value
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={hasError}
          helperText={helperText}
          size={size}
        />
      )}
      fullWidth
    />
  )
}

export default FormikAutocompleteField
